// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__gGVJs","MainPage":"MainPage_MainPage__T01sv","LinkBlock":"MainPage_LinkBlock__yQ9A4","Link":"MainPage_Link__HGpRN","title":"MainPage_title__bf8Tq"};